import {
  Button as MantineButton,
  ButtonProps as MantineButtonProps,
} from '@mantine/core';
import type { ButtonHTMLAttributes } from 'react';

export type ButtonProps = MantineButtonProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, keyof MantineButtonProps>;

export const Button = MantineButton;

Button.displayName = 'Button';
